// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      "id": "",
      "user_email": "",
      "user_password": "",
      "user_name": "",
      "user_phone": "",
      "user_company": "",
      "user_type": "",
      "user_status": "",
      "create_time": "",
      "del_flag": ""
    }
  },
  getters: {
      user: state => {
        return state.user
      }
    },
  mutations: {
    setUser (state,val) {
      state.user  = val
    }
  },
  actions:{
    setUser(val){
      commit('setUser', val)
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js